/* globals webkitURL */

import { TextEncoderLite } from 'text-encoder-lite';

angular.module("tromanWeb").factory('downloadService', ['$log', function ($log) {

    var utf8Encoding = new TextEncoderLite('utf-8');
    var lastObjectUrl = null;

    var hasDownload = (function () {
        var a = document.createElement('a');
        return typeof a.download !== 'undefined';
    });

    var createOURL = URL.createObjectURL || (webkitURL && webkitURL.createObjectURL);
    var revokeOURL = URL.revokeObjectURL || (webkitURL && webkitURL.revokeObjectURL);
    var hasOURL = (typeof createOURL !== 'undefined') && (typeof revokeOURL !== 'undefined');

    function downloadUrl(url, filename) {
        if (hasDownload) {
            try {
                var a = document.createElement('a');
                a.href = url;
                a.target = '_blank';
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    revokeOURL(url);
                    lastObjectUrl = null;
                    a.remove();
                }, 1000);
                return true;
            } catch (err) {
                $log.error('downloadUrl with download failed.', err);
            }
        }

        try {
            return !!window.open(url, '_blank');
        } catch (err) {
            $log.error("downloadUrl with window.open failed.", err);
            return false;
        }
    }

    function downloadBlobOURL(blob, filename) {
        if (!hasOURL)
            return false;

        if (lastObjectUrl != null) {
            revokeOURL(lastObjectUrl);
            lastObjectUrl = null;
        }

        lastObjectUrl = createOURL(blob);
        return downloadUrl(lastObjectUrl, filename);
    }

    function downloadBlob(blob, filename) {

        if (!(blob instanceof Blob))
            throw new TypeError("Blob expected");

        if (window.navigator.msSaveOrOpenBlob) {
            return window.navigator.msSaveOrOpenBlob(blob, filename);
        } else if (hasOURL) {
            return downloadBlobOURL(blob, filename);
        }
        return false;
    }

    var so = {};

    so.downloadText = function downloadText(text, filename, mediaType) {
        /// <summary>Downloads the supplied text as a file. The text is always utf-8 encoded.</summary>
        /// <param name="text" type="String">The text to download</param>
        /// <param name="text" type="String">The suggested filename</param>
        /// <param name="text" type="String" optional="true">The media type (defaults to 'text/plain')</param>
        if (typeof text !== "string") return false;
        if (typeof filename !== "string") return false;
        mediaType = mediaType || 'text/plain';

        try {
            // Prepend BOM
            if (text.charCodeAt(0) !== 0xFEFF) {
                text = "\ufeff" + text;
            }

            var data = utf8Encoding.encode(text);
            var blob = new Blob([data], { type: mediaType + ";charset=utf-8;" });

            if (downloadBlob(blob, filename))
                return true;
        } catch (err) {
            $log.error('Error downloading text file', err);
        }

        $log.error("Not Supported");
        return false;
    };

    so.downloadBlob = downloadBlob;

    return so;

}]);
